<template>
    <div class="container">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item label="客户总数"> ：共{{customerTotal}} 位   
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item> 
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="全部身份" v-model="formObj.userType" @change="multiSearchClick">
                            <el-option label="全部身份" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index" v-for="(list,index) in userTypeOptions"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="全部审核状态" v-model="formObj.authResult" @change="multiSearchClick">
                            <el-option label="全部审核状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index"  v-for="(list,index) in authResultOptions"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                    <!-- <template slot-scope="scope">{{parseInt(searchObj.page-1)*parseInt(searchObj.num) }}</template> -->
                </el-table-column>
                <!-- <el-table-column label="userId" width="70">
					<template slot-scope="scope">{{ scope.row.user_id }}</template>
				</el-table-column>
				<el-table-column label="authId" width="70">
					<template slot-scope="scope">{{ scope.row.auth_id }}</template>
				</el-table-column> -->
                <el-table-column label="公司名称">
                    <template slot-scope="scope">{{ scope.row.company_name }}</template>
                </el-table-column>
                <el-table-column label="注册手机号" width="120">
                    <template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
                </el-table-column>
                <el-table-column label="注册时间" width="160">
                    <template slot-scope="scope">{{ scope.row.user_register_time }}</template>
                </el-table-column>
                <!-- 	<el-table-column label="注册渠道" >
					<template slot-scope="scope">{{ scope.row.token_type | turnValToText("token_type")}}</template>
				</el-table-column> -->
                <el-table-column label="最近登录时间" width="160">
                    <template slot-scope="scope">{{ scope.row.lastLoginTime }}</template>
                </el-table-column>
                <el-table-column label="身份" width="70">
                    <template slot-scope="scope">
                        <!-- <span :class="{green:scope.row.user_type==1,blue:scope.row.user_type==2}">{{ scope.row.user_type | turnValToText("user_type")}}</span> -->
                        <span>{{ scope.row.user_type | turnValToText("user_type")}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="认证状态" width="80">
                    <template slot-scope="scope">
                        <span :class="{grey_lighter:scope.row.auth_result=='y',red:scope.row.auth_result=='p',orange_lighter:scope.row.auth_result=='n'}">{{ scope.row.auth_result | turnValToText("auth_result")}}</span>
                        <span v-if=" !scope.row.auth_result || scope.row.auth_result=='never'" class="orange">未提交</span>
                    </template>
                </el-table-column>
                <el-table-column label="公司所在地">
                    <template slot-scope="scope">{{ scope.row.address }}</template>
                </el-table-column>
                <el-table-column label="操作" width="170">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button type="primary" size="mini" @click="toDetail(scope.row)" v-if="functionViewDetail">查看</el-button>
                          <!--  <el-button type="success" size="mini" @click="openNewLinkModal(scope.row)" 
                                v-if="scope.row.user_type==1&&scope.row.auth_result=='y'&&functionAddOrder " >发单</el-button> -->
                            <el-button type="danger" size="mini" v-if="scope.row.auth_result=='p' &&functionAuthCustomer " @click="openAuth(scope.row)">审核</el-button>
                            <!-- <el-button size="mini"  @click="openAuth(scope.row)">审核11</el-button> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <!-- <div class="ceshi">
			ceshi:
			{{searchObj}}
		</div> -->
        <el-dialog title="发布订单" :visible.sync="isShowAddOrderModal" width="30%" :center="true">
            <div style="text-align: center;">
                 <el-button type="primary" @click="toAddOrder('cmt')">来料加工cmt</el-button>
                 <el-button type="primary"  @click="toAddOrder('oem')">包工包料oem</el-button>
            </div>
        </el-dialog>
        <authmodal :current="currentAuthList" :isShow="isShowModal" @close="closeModal" @submitSucess="getTableLists"></authmodal>
    </div>
</template>

<script>
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost
    } from '@/common/request.js'
    import authmodal from '@/components/authModal.vue'
    import {
        utils
    } from '@/common/common.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                customerTotal: "",
                formObj: {
                    fuzzyQuery: '',
                    userType: '',
                    authResult: '',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                currentAuthList: "12312312312312",
                isShowModal: false,

            }
        },
        computed: {
            functionViewDetail(){
                return utils.getCurrentFunction().indexOf("viewCustomerDetail")>-1
            },
            // functionAddOrder(){
            //     return utils.getCurrentFunction().indexOf("addOrder")>-1
            // },
            functionAuthCustomer(){
                return utils.getCurrentFunction().indexOf("authCustomerIdentitySubmit")>-1
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            adminId() {
                let oUserInfo=utils.getItem('userInfo')?JSON.parse(utils.getItem('userInfo')) :{}
                console.log(oUserInfo.adminId,'computed里的adminId')
                return oUserInfo.adminId
            },
            powerObj(){//获取权限数据
                let buffer={
                    add:[],
                    modify:[],
                    query:[],
                    delete:[]
                }
                let addArr=utils.getItem('haveAddPowerPageJson')?JSON.parse(utils.getItem('haveAddPowerPageJson')) :[]
                let modifyArr=utils.getItem('haveModifyPowerPageJson')?JSON.parse(utils.getItem('haveModifyPowerPageJson')) :[]
                let queryArr=utils.getItem('haveQueryPowerPageJson')?JSON.parse(utils.getItem('haveQueryPowerPageJson')) :[]
                let deleteArr=utils.getItem('haveDeletePowerPageJson')?JSON.parse(utils.getItem('haveDeletePowerPageJson')) :[]
                buffer.add=addArr
                buffer.modify=modifyArr
                buffer.query=queryArr
                buffer.delete=deleteArr
                return buffer
            },
            currentPageId(){//当前页面id
               let currentPath=this.$route.path
               let result=utils.getCurrentPageId(currentPath)
               return result
            },
            
        },
        watch: {
          '$route' (to, from) {
              console.log("路由变化------")
              console.log(to,from)
          }
        },
        components: {
            authmodal
        },
        methods: {
            getParams(){
              this.lastPage=this.$route.query.from  
            },
            back() {
                this.$router.back()
            },
            closeModal() {
                console.log('list.vue 的关闭事件')
                this.isShowModal = false
            },
            openAuth(list) {
                this.currentAuthList = list
                this.isShowModal = true
            },
            
            toAddOrder(type) {
                let _this=this
                let userId = this.newLinkParamObj.user_id
                let companyName = this.newLinkParamObj.company_name
                let user_cellphone = this.newLinkParamObj.user_cellphone
                console.log(userId)
                console.log(companyName)
                this.isShowAddOrderModal=false
                if(type=='cmt'){//来料加工
                    utils.setSearchObjToSession(_this.searchObj)
                    this.$router.push({
                        name: 'orderAddCmt',
                        params: {
                            userId: userId,
                            companyName: companyName,
                            user_cellphone:user_cellphone
                        }
                    })
                    
                }
                if(type=='oem'){//包工包料
                    utils.setSearchObjToSession(_this.searchObj)
                     this.$router.push({
                        name: 'orderAddOem',
                        params: {
                            userId: userId,
                            companyName: companyName,
                            user_cellphone:user_cellphone
                        }
                    })
                   
                }
                
            },
            openNewLinkModal(list){
                console.log(list)
                this.isShowAddOrderModal=true
                this.newLinkParamObj=list
            },
            toDetail(list) {
                let _this = this
                let userId = list.user_id
                if (!userId) {
                    _this.$message({
                        message: "该条数据有误，没有userId", //接口返回一个页面
                        type: 'error',
                        duration: 1500
                    });
                } else {
                    utils.setSearchObjToSession(_this.searchObj)
                    this.$router.push({
                        name: 'customerDetail',
                        params: {
                            userId: userId,
                            href: 'customer'
                        }
                    })
                }
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    authResult: this.formObj.authResult,
                    userType: this.formObj.userType,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/admin/yijiajiaUserAuth/findUserAuthList', this.searchObj).then(function(res) {
                    _this.tableData = []
                    _this.isLoading = false
                    _this.customerTotal = res.data.totalCount
                    if (res.data && res.data.userAuthList) {
                        _this.total = res.data.queryTotalCount
                        res.data.userAuthList.forEach(function(item, index) {
                            let buffer = {}
                            //id,名字，手机号，注册时间，渠道，身份，状态，地址
                            buffer.auth_id = item.auth_id
                            buffer.user_id = item.user_Id
                            buffer.company_name = item.company_name
                            buffer.user_cellphone = item.user_cellphone
                            buffer.user_register_time = item.user_register_time
                            // buffer.token_type=item.token_type
                            buffer.lastLoginTime = item.lastLoginTime
                            buffer.user_type = item.userType
                            buffer.auth_result = item.auth_result
                            item.company_province = item.company_province || ""
                            item.company_city = item.company_city || ""
                            item.company_district = item.company_district || ""
                            buffer.address = item.company_province + item.company_city + item.company_district
                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            handleSelectionChange(val) { //表格多选框
                this.multipleSelection = val;
                console.log(this.multipleSelection)
            }
        },
        created() {
            console.log("执行created")
        	//获取session里存储的搜索条件，并赋值给当前表单
            this.getParams()
            
            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                this.formObj.userType=_this.searchObj.userType
                this.formObj.authResult=_this.searchObj.authResult
            }else if(_this.lastPage=='home'){
                _this.searchObj.authResult='p'
                this.formObj.authResult=_this.searchObj.authResult
            }else{
                console.log("session里没有搜索条件，也不是首页直接跳转")
            }
            console.log(_this.searchObj,'mounted里的搜索条件1111')
            this.getTableLists()
        
        },
        mounted(){
            console.log("执行mounted")
        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }

    .container {}

    .searchBox {
        padding: 0.25rem 0.25rem 0;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/list.vue